<template>
  <div v-if="preset" ref="presetItem" class="preset--item">
    <div class="content" :class="{ linked: isLinkedPreset }">
      <div class="preset" @click.prevent="onClickPreset">
        <template v-if="typeof headingPreset === 'string'">
          <label class="label--preset gf_truncate">{{ headingPreset }}</label>
        </template>
        <template v-else>
          <div
            :style="{
              fontSize: headingPreset.baseSize,
              lineHeight: headingPreset.baseSize,
            }">
            <label
              class="label--preset gf_truncate"
              :style="{
                fontSize: headingPreset.fontSize,
                fontStyle: headingPreset.fontStyle,
                fontWeight: headingPreset.fontWeight,
                fontFamily: headingPreset.headingFont,
                lineHeight: headingPreset.lineHeight,
              }">
              {{ headingPreset.headingFontLabel }}
            </label>
          </div>
        </template>
        <button ref="edit" v-click-away="outSide" v-tooltip.top="'More options'" class="edit" @click="onShowAction">
          <div class="edit--content">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.36444 7.43649C3.04908 7.12816 2.53964 7.12816 2.22427 7.43649C1.90646 7.74722 1.90646 8.25278 2.22427 8.56351C2.53964 8.87184 3.04908 8.87184 3.36444 8.56351C3.68226 8.25278 3.68226 7.74722 3.36444 7.43649ZM4.06473 6.7641C3.36364 6.07863 2.22508 6.07863 1.52398 6.7641C0.825339 7.44716 0.825339 8.55284 1.52398 9.2359C2.22508 9.92136 3.36364 9.92136 4.06473 9.2359C4.76338 8.55284 4.76338 7.44716 4.06473 6.7641ZM13.7757 7.43649C13.4604 7.12816 12.9509 7.12816 12.6356 7.43649C12.3177 7.74722 12.3177 8.25278 12.6356 8.56351C12.9509 8.87184 13.4604 8.87184 13.7757 8.56351C14.0935 8.25278 14.0935 7.74722 13.7757 7.43649ZM11.9353 6.7641C12.6364 6.07863 13.7749 6.07863 14.476 6.7641C15.1747 7.44716 15.1747 8.55284 14.476 9.2359C13.7749 9.92136 12.6364 9.92136 11.9353 9.2359C11.2366 8.55284 11.2366 7.44716 11.9353 6.7641ZM7.43016 7.43649C7.74552 7.12816 8.25496 7.12816 8.57032 7.43649C8.88814 7.74722 8.88814 8.25278 8.57032 8.56351C8.25496 8.87184 7.74552 8.87184 7.43016 8.56351C7.11234 8.25278 7.11234 7.74722 7.43016 7.43649ZM9.27062 6.7641C8.56952 6.07863 7.43096 6.07863 6.72987 6.7641C6.03122 7.44716 6.03122 8.55284 6.72987 9.2359C7.43096 9.92137 8.56952 9.92137 9.27062 9.2359C9.96926 8.55284 9.96926 7.44716 9.27062 6.7641Z"
                fill="white" />
            </svg>
          </div>
        </button>
        <template v-if="typeof headingPreset === 'string'">
          <span class="description--preset"> The quick brown fox jumps over the lazy... </span>
        </template>
        <template v-else>
          <div
            :style="{
              fontSize: paragraphPreset.baseSize,
              lineHeight: paragraphPreset.baseSize,
            }">
            <span
              class="description--preset"
              :style="{
                fontSize: paragraphPreset.fontSize,
                fontStyle: paragraphPreset.fontStyle,
                fontWeight: paragraphPreset.fontWeight,
                fontFamily: paragraphPreset.paragraphFont,
                lineHeight: paragraphPreset.lineHeight,
              }">
              The quick brown fox jumps over the lazy...
            </span>
          </div>
        </template>
        <ul class="colors">
          <li v-for="(color, index) in previewColor" :key="index" class="item">
            <div class="alpha" :style="{ background: color }"></div>
          </li>
        </ul>
        <Teleport v-if="actionShow" to="#menu-action">
          <div v-if="actionShow" class="preset--actions" :style="presetStyle">
            <div class="menu-items">
              <div class="menu" @click="edit">
                <svg
                  class="icon"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.7773 1.22266C12.4616 0.906945 11.9497 0.906946 11.634 1.22265L11.3691 1.48748L12.5125 2.63077L12.7773 2.36594C13.093 2.05023 13.093 1.53836 12.7773 1.22266ZM6.22876 6.62765L10.672 2.1846L11.8153 3.32788L7.37203 7.77099L6.03832 7.96176L6.22876 6.62765ZM10.9368 0.525537C11.6376 -0.17518 12.7737 -0.175178 13.4744 0.525537C14.1752 1.22625 14.1752 2.36233 13.4744 3.06305L7.95302 8.58425C7.87762 8.65965 7.77981 8.70856 7.67425 8.72366L5.52723 9.03078C5.37362 9.05275 5.21864 9.00112 5.1089 8.89142C4.99916 8.78172 4.94748 8.62676 4.96941 8.47316L5.27596 6.32564C5.29104 6.22003 5.33997 6.12217 5.4154 6.04674L10.9368 0.525537ZM0.985912 3.96382C0.985912 3.75692 1.15365 3.58919 1.36056 3.58919H5.69857C5.97082 3.58919 6.19153 3.3685 6.19153 3.09626C6.19153 2.82402 5.97082 2.60332 5.69857 2.60332H1.36056C0.609143 2.60332 0 3.21244 0 3.96382V12.6395C0 13.3909 0.609143 14 1.36056 14H10.0366C10.788 14 11.3971 13.3909 11.3971 12.6395V8.30166C11.3971 8.02942 11.1764 7.80872 10.9042 7.80872C10.6319 7.80872 10.4112 8.02942 10.4112 8.30166V12.6395C10.4112 12.8464 10.2435 13.0141 10.0366 13.0141H1.36056C1.15365 13.0141 0.985912 12.8464 0.985912 12.6395V3.96382Z"
                    fill="white" />
                </svg>
                <span class="menu-label">Edit</span>
              </div>
              <div class="menu" :class="{ disabled: shouldDisableApplyPreset }" @click="preview">
                <i class="icon icon-preview-mode"></i>
                <span class="menu-label">Enable Preview Mode</span>
              </div>
              <div class="menu" @click="duplicate">
                <svg
                  class="icon"
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.60135 1.36059C2.60135 1.09811 2.76749 0.985932 2.86278 0.985932H10.8155C10.9108 0.985932 11.0769 1.09811 11.0769 1.36059V10.9044C11.0769 11.1669 10.9108 11.2791 10.8155 11.2791H2.86278C2.76749 11.2791 2.60135 11.1669 2.60135 10.9044V1.36059ZM2.86278 0C2.15951 0 1.67827 0.664728 1.67827 1.36059V10.9044C1.67827 11.6003 2.15951 12.265 2.86278 12.265H10.8155C11.5188 12.265 12 11.6003 12 10.9044V1.36059C12 0.664728 11.5188 0 10.8155 0H2.86278ZM0.923082 2.22797C0.923082 1.95572 0.716443 1.73501 0.461541 1.73501C0.206639 1.73501 0 1.95572 0 2.22797V12.6394C0 13.3353 0.481238 14 1.18451 14H9.86019C10.1151 14 10.3217 13.7793 10.3217 13.507C10.3217 13.2348 10.1151 13.0141 9.86019 13.0141H1.18451C1.08922 13.0141 0.923082 12.9019 0.923082 12.6394V2.22797Z"
                    fill="white" />
                </svg>
                <span class="menu-label">Duplicate as New Preset</span>
              </div>
              <div class="menu" :class="{ disabled: shouldDisableApplyPreset }" @click="applyCurrentPage">
                <svg
                  class="icon"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    :fill="shouldDisableApplyPreset ? '#757575' : 'white'"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0463 1.12012C10.2601 1.03152 10.4892 0.985923 10.7207 0.985923C10.9521 0.985923 11.1813 1.03152 11.3951 1.12012C11.6089 1.20872 11.8032 1.33857 11.9668 1.50227L11.9671 1.50254L12.4982 2.03307L12.4983 2.03316C12.8285 2.36356 13.0141 2.8116 13.0141 3.27878C13.0141 3.74598 12.8285 4.19406 12.4982 4.52447L12.4982 4.52448L9.04323 7.98003L9.04318 7.98009C8.87956 8.14378 8.6853 8.27364 8.47148 8.36224C8.25766 8.45083 8.02849 8.49643 7.79704 8.49643C7.5656 8.49643 7.33642 8.45083 7.1226 8.36224C6.90883 8.27366 6.7146 8.14384 6.55101 7.98019L6.5509 7.98009L6.01969 7.4483C5.82728 7.25569 5.51516 7.25552 5.32254 7.44793C5.12993 7.64034 5.12976 7.95247 5.32217 8.14508L5.85349 8.67697L5.85359 8.67707C6.10876 8.93237 6.41174 9.13489 6.7452 9.27307C7.07866 9.41124 7.43608 9.48236 7.79704 9.48236C8.158 9.48236 8.51542 9.41124 8.84888 9.27307C9.18232 9.1349 9.48527 8.9324 9.74044 8.67713L9.74049 8.67707L13.1954 5.22157L13.1954 5.22156C13.7106 4.70626 14 4.00743 14 3.27878C14 2.55012 13.7106 1.85129 13.1954 1.336L13.1952 1.33577L12.6641 0.805286C12.409 0.549987 12.106 0.347466 11.7725 0.209292C11.4391 0.0711184 11.0816 0 10.7207 0C10.3597 0 10.0023 0.0711183 9.66885 0.209292C9.33544 0.347443 9.03251 0.549921 8.77736 0.805161L8.77724 0.805286L6.3856 3.19638C6.19306 3.38887 6.19302 3.701 6.38551 3.89354C6.578 4.08607 6.89013 4.08611 7.08266 3.89362L9.47443 1.5024L9.47455 1.50227C9.63817 1.33857 9.83243 1.20872 10.0463 1.12012ZM4.95665 6.01999L4.95677 6.01987C5.28736 5.68951 5.73559 5.50394 6.20296 5.50394C6.67038 5.50394 7.11867 5.68956 7.44927 6.01999L7.98031 6.5516C8.17272 6.74421 8.48484 6.74438 8.67745 6.55197C8.87007 6.35956 8.87024 6.04743 8.67783 5.85482L8.14651 5.32293L8.14624 5.32265C7.63075 4.80744 6.93177 4.51801 6.20296 4.51801C5.47415 4.51801 4.77516 4.80744 4.25968 5.32265L4.25956 5.32277L0.8046 8.77834L0.804589 8.77835C0.289413 9.29364 0 9.99247 0 10.7211C0 11.4498 0.289413 12.1486 0.804589 12.6639L0.804628 12.6639L1.33594 13.1953L1.33603 13.1954C1.85152 13.7106 2.5505 14 3.27931 14C4.00812 14 4.70711 13.7106 5.22259 13.1954L5.22268 13.1953L7.61445 10.8035C7.80696 10.611 7.80696 10.2988 7.61444 10.1063C7.42193 9.91381 7.10981 9.91381 6.9173 10.1063L4.52562 12.498L4.52553 12.4981C4.19494 12.8285 3.74669 13.0141 3.27931 13.0141C2.81189 13.0141 2.3636 12.8285 2.033 12.498L1.50181 11.9668L1.50178 11.9668C1.17147 11.6364 0.985914 11.1883 0.985914 10.7211C0.985914 10.2539 1.17149 9.80583 1.50181 9.47542L4.95665 6.01999Z" />
                </svg>
                <span class="menu-label">Apply to current page</span>
              </div>
              <div
                :class="['menu menu-danger', { disabled: preset?.linkedPages && preset?.linkedPages.length }]"
                :title="preset?.linkedPages && preset?.linkedPages.length ? 'Preset is linked' : ''"
                @click="deletePreset">
                <i class="icon icon-delete"></i>
                <span class="menu-label text-danger">Delete Preset</span>
              </div>
            </div>
          </div>
        </Teleport>
      </div>
      <div class="gf_preset__footer" :class="{ 'gf_preset__footer--edit': isRenamePreset }">
        <div class="gf_preset__footer__left">
          <div
            v-if="tooltips.show"
            class="message-errors"
            :style="{ 'max-width': tooltips.maxWidth, top: tooltips.top, width: tooltips.width }">
            <label class="label">
              {{ isValid ? preset?.name : tooltips.message }}
            </label>
          </div>
          <span v-if="isLinkedPreset" class="mr-4px mt-4px">
            <i class="icon icon-check"></i>
          </span>
          <span
            v-if="!isRenamePreset"
            class="gf_preset__footer__left-name"
            @mouseover="elementNameHover(true)"
            @mouseleave="elementNameHover(false)"
            @click="elementNameClick()"
            >{{ preset?.name }}</span
          >
          <input
            v-if="isRenamePreset"
            ref="editInput"
            v-model.trim="presetInputName"
            :style="[isValid ? '' : { border: '1px solid #F44336' }]"
            class="gf_preset__input__name"
            placeholder="New style name"
            type="text"
            @input="onTypingChange"
            @focusout="onInputChange(true)"
            @blur="onInputChange(false)"
            @keyup.enter="onInputChange(false)"
            @keyup.esc="onInputChange(false)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { Preset } from '@/types/global-style';
import { DEFAULT_COLOR_BRAND, DEFAULT_COLOR_NEUTRAL } from '@modules/editor-sidebar';
import { mapActions, mapMutations, mapState } from 'vuex';
import { actions } from '@modules/editor-sidebar';
import { mutations as mutaIframe } from '@/store/iframe/types';
import { cloneDeep } from '@/utils/common';
import { actions as commonActions } from '@/store/common/types';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { $gfLeftSideBar, $gryffBody } from '@/app/index';

interface DataInterface {
  actionShow: boolean;
  presetStyle: any;
  isRenamePreset: boolean;
  tooltips: any;
  tooltipStyleLine: any;
  isValid: boolean;
  presetInputName: string;
  styleArrowPopupOB: any;
  stylePopupOb: any;
}

export default defineComponent({
  name: 'PresetItem',
  props: {
    preset: {
      type: Object as () => Preset,
    },
    indexItem: {
      type: Number,
    },
  },
  emits: ['edit', 'duplicate', 'applyCurrentPage', 'applyOtherPage', 'delete', 'preview'],
  data: (): DataInterface => ({
    actionShow: false,
    presetStyle: {},
    isRenamePreset: false,
    stylePopupOb: {
      position: 'absolute',
      top: '169px',
      right: '-302px',
    },
    styleArrowPopupOB: {
      position: 'absolute',
      top: '45px',
      left: '-8px',
    },
    tooltips: {
      show: false,
      message: '',
      maxWidth: '',
      width: '',
    },
    tooltipStyleLine: {
      one: {
        top: '-32px',
        width: 'fit-content',
      },
      two: {
        top: '-45px',
        width: '138px',
      },
      three: {
        top: '-60px',
        width: '230px',
      },
    },
    isValid: true,
    presetInputName: '',
  }),
  computed: {
    ...mapState('sidebar', {
      presetsData: (state) => (state as any).presets,
      previewPreset: (state) => (state as any).previewPreset,
      linkedPresetId: (state) => (state as any).linkedPresetId,
    }),
    ...mapState('app', {
      shopMeta: 'shopMeta',
      pageInfo: 'pageInfo',
    }),
    shouldDisableApplyPreset() {
      const presetId = this?.pageInfo?.page?.preset_id;
      return this.preset?.id === presetId;
    },
    headingPreset() {
      if (this.preset?.presetOptions?.texts) {
        const presetText = this.preset.presetOptions.texts;
        const indexText = presetText.findIndex((item: any) => item.subType === 'heading');
        if (indexText !== -1) {
          const value = cloneDeep(presetText[indexText].value);
          value.fontSize = '20px';
          value.lineHeight = '1.2em';
          value.headingFontLabel = value.headingFont;
          if (value.headingFont === 'inherit') {
            value.headingFontLabel = 'Heading';
          }
          return value;
        }
      }
      return 'Heading';
    },
    paragraphPreset() {
      if (this.preset?.presetOptions?.texts) {
        const presetText = this.preset.presetOptions.texts;
        const indexText = presetText.findIndex((item: any) => item.subType === 'paragraph');
        if (indexText !== -1) {
          const value = cloneDeep(presetText[indexText].value);
          value.fontSize = '12px';
          value.lineHeight = '1.5em';
          return value;
        }
      }
      return 'Paragraph';
    },
    colorBrandPreset() {
      if (this.preset?.presetOptions?.colors && this.preset?.presetOptions?.colors?.length > 0) {
        return this.preset?.presetOptions?.colors[0].value.brand;
      }
      return DEFAULT_COLOR_BRAND;
    },
    colorNeutralPreset() {
      if (this.preset?.presetOptions?.colors && this.preset?.presetOptions?.colors?.length > 0) {
        return this.preset?.presetOptions?.colors[0].value.neutral;
      }
      return DEFAULT_COLOR_NEUTRAL;
    },
    previewColor() {
      const colorNeutralPreset = this.colorNeutralPreset;
      const color1 = Object(colorNeutralPreset)[Object.keys(colorNeutralPreset)[0]];
      const color3 = Object(colorNeutralPreset)[Object.keys(colorNeutralPreset)[2]];
      return [color1, ...Object.values(this.colorBrandPreset), color3];
    },
    isLinkedPreset() {
      return this.linkedPresetId == this.preset?.id;
    },
  },
  watch: {
    presetInputName(newValue) {
      this.validateItemName(newValue);
    },
  },
  mounted() {
    const $presetItem = this.$refs.presetItem as any;
    if ($presetItem && $presetItem.offsetParent) {
      $presetItem.offsetParent.addEventListener('scroll', () => {
        this.onCloseMoreOptions();
      });
    }
  },
  methods: {
    ...mapActions('sidebar', {
      updatePreset: actions.UPDATE_PRESET,
    }),
    ...mapMutations('iframe', {
      ALERT: mutaIframe.ALERT,
    }),
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    ...mapActions('common', {
      trackEvent: commonActions.TRACK_EVENT,
    }),
    onClickPreset(e: any) {
      const $edit = this.$refs.edit as any;
      if ($edit && $edit.contains(e.target)) {
        return;
      }
      this.edit();
    },
    edit(): void {
      this.$emit('edit', this.preset);
    },
    duplicate(): void {
      this.$emit('duplicate', this.preset);
    },
    applyCurrentPage(): void {
      if (this.shouldDisableApplyPreset) return;
      this.$emit('applyCurrentPage', this.preset);
    },
    applyOtherPage(): void {
      this.$emit('applyOtherPage', this.preset);
    },
    deletePreset(): void {
      if (this.preset?.linkedPages && this.preset?.linkedPages.length) {
        return;
      }

      this.$emit('delete', { preset: this.preset, index: this.indexItem });
    },
    onShowAction(e: any): void {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_PRESET_MORE_OPTIONS_CLICKED });

      this.actionShow = !this.actionShow;
      const _this = this;
      if (this.actionShow) {
        $gfLeftSideBar().data('gfleftsidebar').onBackgroundIframe('backgroundAdv');
        setTimeout(function () {
          $gryffBody()
            .find('.backgroundAdv')
            .off('mousedown.removeBackground')
            .on('mousedown.removeBackground', function () {
              _this.onCloseMoreOptions();
            });
        }, 0);
      } else {
        $gfLeftSideBar().data('gfleftsidebar').offBackgroundIframe('backgroundAdv');
      }
      const clientY = e.clientY;
      const actionHeight = 208;
      let top = 0;
      if (window.innerHeight - clientY - 45 < actionHeight) {
        top = clientY - actionHeight - 85;
      } else {
        top = clientY - 45;
      }

      this.presetStyle = {
        top: top + 'px',
      };
    },
    outSide(): void {
      this.onCloseMoreOptions();
    },
    onCloseMoreOptions() {
      this.actionShow = false;
      if ($gfLeftSideBar()?.data('gfleftsidebar')) {
        $gfLeftSideBar().data('gfleftsidebar').offBackgroundIframe('backgroundAdv');
      }
    },
    preview() {
      if (this.shouldDisableApplyPreset) return;
      this.$emit('preview', this.preset);
      this.$emit('edit', this.preset);
    },
    elementNameHover(state: boolean): void {
      this.tooltips = {
        show: state,
        width: this.tooltipStyleLine.one.width,
        top: this.tooltipStyleLine.one.top,
        message: 'Click to rename',
      };
      return;
    },
    elementNameClick() {
      this.isRenamePreset = true;
      this.tooltips.show = false;
      this.presetInputName = this.preset?.name || '';
      setTimeout(() => {
        const $input = this.$refs.editInput as any;
        if ($input) {
          $input.focus();
        }
      }, 100);
    },
    onTypingChange(e: any) {
      const value = e.target.value;
      this.validateItemName(value);
    },
    async onInputChange(isReset: boolean) {
      if (isReset) {
        this.isValid = true;
        this.isRenamePreset = false;
        this.tooltips.show = false;
        this.presetInputName = this.preset?.name || '';
        return;
      }
      const valid: boolean = this.validateItemName(this.presetInputName);
      if (valid) {
        this.isRenamePreset = false;
        if (this.presetInputName.trim() === this.preset?.name) {
          return;
        }
        this.ALERT({ show: true, title: 'Updating', message: this.preset?.name, typeAlert: 'info', delay: 'infinity' });
        try {
          const presetPrev = cloneDeep(this.preset);
          if (this.preset) {
            // eslint-disable-next-line vue/no-mutating-props
            this.preset.name = this.presetInputName.trim();
          }
          const res = await this.updatePreset({
            presetId: this.preset?.id,
            data: this.preset,
          });
          if (res.status === 'success') {
            this.ALERT({
              show: true,
              title: 'Update',
              message: 'name preset successfully.',
              typeAlert: 'success',
            });
          } else {
            this.presetInputName = presetPrev.name;
            if (this.preset) {
              // eslint-disable-next-line vue/no-mutating-props
              this.preset.name = presetPrev.name;
            }
            let title = 'Update';
            let message = 'name preset failed. Please check your internet connection then try again later';
            if (res.errorCode === 'GS00006') {
              title = '';
              message = `${this.preset?.name} is already <span class="typo-semibold">deleted</span>. Please save your progress and reload the editor to see the changes.`;
            }
            this.ALERT({
              show: true,
              title: title,
              message: message,
              typeAlert: 'error',
            });
            this.$forceUpdate();
          }
        } catch (error) {
          this.ALERT({
            show: true,
            title: 'Update',
            message: 'name preset failed. Please check your internet connection then try again later',
            typeAlert: 'error',
          });
        }
      }
      return;
    },
    validateItemName(name: string) {
      const presetId = this.preset?.id;
      this.tooltips.show = false;
      const existItem = this.presetsData.filter((preset: Preset) => {
        if (preset.id != presetId) {
          return preset.name.trim().toLowerCase() === name.trim().toLowerCase();
        }
      });
      if (existItem.length > 0) {
        this.tooltips = {
          show: true,
          width: this.tooltipStyleLine.three.width,
          top: this.tooltipStyleLine.three.top,
          message: this.$t('sidebarGS.styleDetail.general.errorInputNameExisted'),
        };
        this.isValid = false;
        return false;
      }
      if (name.length > 30) {
        this.tooltips = {
          show: true,
          width: this.tooltipStyleLine.two.width,
          top: this.tooltipStyleLine.two.top,
          message: this.$t('sidebarGS.styleDetail.general.errorInputNameMax', { maxLength: 30 }),
        };
        this.isValid = false;
        return false;
      }
      if (name.length === 0) {
        this.tooltips = {
          show: true,
          width: this.tooltipStyleLine.one.width,
          top: this.tooltipStyleLine.one.top,
          message: this.$t('sidebarGS.styleDetail.general.errorInputNameBlank'),
        };
        this.isValid = false;
        return false;
      }
      this.isValid = true;
      return true;
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.content {
  border: 1px solid #323232;
  border-radius: 3px;

  &:hover {
    border: 1px solid #d6d6d6;
  }

  &:focus {
    border: 1px solid #d6d6d6;
  }

  &.linked {
    border: 2px solid map-get($primary-blue-ui-kit, '300');
  }
}

.preset--item {
  padding: 0 12px 0 12px;
  margin-bottom: 16px;
  cursor: pointer;
}

.preset {
  background: map-get($hybrid-shade-dark, '200');
  padding: 12px;
  position: relative;
  border-radius: 3px 3px 0px 0px;

  .edit {
    &:hover {
      background-color: map-get($hybrid-shade-dark, '300');
      border-radius: 3px;
      transition: none !important;
    }

    .edit--content {
      @include flex-center;
      width: 32px;
      height: 32px;
    }

    @include flex-center;
    width: 32px;
    height: 32px;
    position: absolute;
    top: 8px;
    right: 8px;
    background: none;
    border: none;
  }

  .label--preset {
    font-weight: 600;
    font-size: 20px;
    color: #aaaaaa;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 4px;
    margin-bottom: 2px;
    padding: 0;
    padding-right: 30px;
  }

  .description--preset {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #aaaaaa;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    margin: 4px 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
  }

  .colors {
    padding: 0;
    margin-top: 12px;
    border: 1px solid map-get($hybrid-shade-dark, '100');
    border-radius: 3px;
  }

  .item {
    position: relative;
    width: calc(100% / 5);
    height: 32px;
    margin: 0 0;
    box-sizing: border-box;
    vertical-align: top;
    display: inline-block;

    &:first-child {
      .alpha {
        border-radius: 3px 0 0 3px;
      }
    }

    &:last-child {
      .alpha {
        border-radius: 0 3px 3px 0;
      }
    }
  }

  .alpha {
    height: 100%;
  }
}

.gf_preset__footer {
  height: 40px;
  background: $black2;
  border-radius: 0 0 3px 3px;
  display: flex;

  &__left {
    flex-basis: 0;
    flex-grow: 1;
    max-width: calc(100% - 10px);
    font-style: normal;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
    padding-left: 12px;
    position: relative;

    &-name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: block;
      width: fit-content;
      cursor: initial;
      border: 1px solid transparent;
      margin: -4px;
      padding: 4px;
      margin-right: 0;
    }

    .message-errors {
      @include flex-center;
      background: map-get($text-light-mode, 'low-contrast');
      border-radius: 4px;
      width: fit-content;
      margin: 0;
      position: absolute;
      top: 0;
      left: 8px;

      .label {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #ffffff;
        padding: 8px;
      }

      &:after {
        content: '';
        position: absolute;
        left: 30px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid map-get($text-light-mode, 'low-contrast');
        clear: both;
        bottom: -6px;
      }
    }
  }

  &.gf_preset__footer--edit {
    .gf_preset__footer {
      &__left {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
    }
  }

  .gf_preset__input__name {
    cursor: initial;
    background-color: map-get($hybrid-shade-dark, '400');
    color: $highlight2;
    border-radius: $radius;
    margin: -4px;
    padding: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    border: 1px solid transparent;
    margin-right: 4px;
    transition: border-color 0.1s ease-out;

    &:focus {
      cursor: text;
      border: 1px solid map-get($primary-blue, '275');
    }
  }
}

.preset--actions {
  position: absolute;
  width: 200px;
  right: -155px;
  background: #323232;
  box-shadow: 0 12px 38px rgba(34, 34, 34, 0.0393604), 0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545),
    0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455),
    0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14);
  border-radius: $radius;
  z-index: 99;

  .menu-items {
    .menu-label {
      margin-left: 4px;
    }

    .menu {
      display: flex;
      align-items: center;
      background: #323232;
      border-radius: 3px;
      flex: none;
      order: 0;
      flex-grow: 1;
      font-size: 12px;
      color: #ffffff;
      cursor: pointer;
      height: 32px;
      margin: 8px;

      .icon {
        margin-left: 9px;
        margin-right: 9px;
        font-size: 14px;
      }

      &:not(.disabled):hover {
        background: #494949;
      }

      &.menu-danger {
        color: map-get($accent-color-red, '300');

        &:not(.disabled):hover {
          color: #ffffff !important;
          background: map-get($accent-color-red, '300') !important;

          .text-danger {
            color: #ffffff !important;
          }
        }
      }

      &.disabled {
        color: $text-dark-disabled;

        .text-danger {
          color: $text-dark-disabled !important;
        }
      }
    }
  }
}

// eslint-disable-next-line vue-scoped-css/no-unused-selector
.gf_preset__edited {
  background: #fdb913;
  border-radius: 3px;
  font-size: 12px;
  padding: 1px 4px;
  color: #212121;
  font-weight: 500;
}

.icon-check {
  color: map-get($accent-color-green, '300');
}

.icon-preview-mode {
  font-size: 16px;
  margin-left: 7px;
}
</style>
